<template>
  <baseEdit />
</template>

<script>
  import baseEdit from './baseEdit';

  export default {
    name: 'transferEdit',
    components: {
      baseEdit,
    },
  };
</script>
